import React from 'react';
import { useLocation } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useChatSidebar } from '@/contexts/ChatSidebarContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

export const ChatSidebarToggle: React.FC = () => {
  const location = useLocation();
  const { isOpen, toggleSidebar } = useChatSidebar();
  const isMobile = useIsMobile();
  
  // Don't render on the chat page
  if (location.pathname === '/chat') {
    return null;
  }
  
  // Don't render on mobile devices at all
  if (isMobile) {
    return null;
  }
  
  // Don't render when sidebar is open
  if (isOpen) {
    return null;
  }
  
  return (
    <Button
      onClick={toggleSidebar}
      className={cn(
        "fixed z-[80] h-12 w-12 rounded-full shadow-lg transition-all duration-300 ease-in-out",
        "bg-indigo-600 hover:bg-indigo-700 text-white border-0",
        "focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-background",
        // Position in corner when sidebar closed
        "bottom-6 right-6",
        // Hover effects
        "hover:scale-110 active:scale-95",
        // Animation when sidebar opens/closes
        "transform transition-transform"
      )}
      title="Open chat"
    >
      <MessageSquare className="h-5 w-5" />
    </Button>
  );
}; 